import { useEffect, useState } from "react";
import { isCancelledRead, loadDefaultConflicts } from "./defaultConflictsApi";

export default function useDefaultConflictRules(getAuth, enabled, revision) {
  const [state, setState] = useState({ byRule: {}, loading: false, error: "" });
  useEffect(() => {
    if (!enabled) return;
    const controller = new AbortController();
    const { signal } = controller;
    setState({ byRule: {}, loading: true, error: "" });
    (async () => {
      const items = await loadDefaultConflicts(getAuth, signal);
      const byRule = {};
      const add = (item, conflicts) => Object.entries(conflicts).forEach(([site, conflict]) => {
        conflict.candidates.forEach((candidate) => {
          byRule[candidate.ruleId] = byRule[candidate.ruleId] || {};
          byRule[candidate.ruleId][item.key + site] = { key: item.key, site, conflict };
        });
      });
      if (signal.aborted) return;
      // Solo conflitti a livello MODA: le regole con condizioni Mongo si vedono nel
      // wizard, che verifica gli articoli reali. Una verify per combinazione a ogni
      // caricamento della pagina peserebbe troppo sul cluster Mongo.
      items.forEach((item) => add(item, item.defaultConflicts));
      setState({ byRule, loading: false, error: "" });
    })().catch((error) => {
      if (!isCancelledRead(error, signal)) setState((current) => ({
        ...current, loading: false, error: error?.response?.data?.error || error.message,
      }));
    });
    return () => controller.abort();
  }, [enabled, getAuth, revision]);
  return state;
}
